function preload(arrayOfImages) {
    $(arrayOfImages).each(function(){
        $('<img/>')[0].src = this;
        // Alternatively you could use:
        // (new Image()).src = this;
    });
}

$(document).ready(function(){
  
  
  /*
  $('#header-nav ul li').on('mouseover', function() {
    $('ul', this).css({ 'left' : -$(this).width()/2 -12 });
    $('ul', this).fadeIn();
  })
  $('#tfHeader').on('mouseout', function() {
    $('ul li ul', this).fadeOut();
  })
  */
  
  	preload([ "//www.tammyfender.com/cdn/shop/t/14/assets/tf-sign-up-background.jpg?v=33407503086448969041785146091" ]);
  
	if(window.location.hash && $('#contact_form input[type=email]').length) {
		$('#contact_form input[type=email]').focus();
    }      
             
  $('.newsletter-signup-header').on('click', function(e) {
    e.preventDefault();
  $('#newsletter').fancybox({wrapCSS: 'newsletter_popup', padding: [40, 40, 40, 40], scrolling: false, maxWidth: 480, minWidth: 250});
        $('#newsletter').trigger('click');
  })
  
  
  if ($('a[href$="#consultation-widget"]').length) {
    $('a[href$="#consultation-widget"]').magnificPopup({
       type: 'inline',
      mainClass: 'mfp-fade',
      closeBtnInside: true
    });
  }



	 var sPageURL = window.location; console.log(sPageURL);
      var pattern = /slide2/;
      var exists = pattern.test(sPageURL);
    if (exists) { 
		 $('.flexslider').flexslider(1);
    }
       
  
  	
	 var sPageURL = window.location.search.substring(1);
      var pattern = /consultation/;
      var exists = pattern.test(sPageURL);
    if (exists) { 
		 $('a[href$="#consultation-widget"]').trigger('click');
    }
       
  
	if ($('#consultation-widget-trigger').length) {
	 $('a[href$="#consultation-widget"]').trigger('click');
	}


  if ( $('body.blog .excerpt, body.article .excerpt').length) {
    $('.excerpt').succinct({
            size: 80
        });
  }
                                               
   
  if($('.magnificOffering').length) {
    $('.magnificOffering').magnificPopup({
       type: 'inline',
      mainClass: 'mfp-fade',
      closeBtnInside: true,fixedBgPos: true,
		fixedContentPos: true,
      gallery: {
  		enabled: true
		},
		callbacks: {
			/*
			close: function() {
          		if (location.hash) history.go(-1);
        	}, */
          	open: function() {
            	$('body.page-spa .mfp-wrap, body.page-spa-menu-west-palm-beach .mfp-wrap, body.page-spa-menu-delray .mfp-wrap').css( 'background-image','url( //www.tammyfender.com/cdn/shop/t/14/assets/tammy-fender-spa-services.jpg?v=85199777154166774041785146093 )');
          	},     
			change: function() {
			    jQuery('.mfp-wrap').scrollTop(0);
			}
    	}
    });
  }
  

  if($('.magnificSpaEtiquette').length) {
    $('.magnificSpaEtiquette').magnificPopup({
       type: 'inline',
      mainClass: 'mfp-fade',
      closeBtnInside: true,fixedBgPos: true,
		fixedContentPos: true,
      gallery: {
  		enabled: false
		},
		callbacks: {
			change: function() {
			    jQuery('.mfp-wrap').scrollTop(0);
			}
    	}
    });
  }
  
   
  if($('.magnificStaff').length) {
    $('.magnificStaff').magnificPopup({
       type: 'inline',
      mainClass: 'mfp-fade',
      closeBtnInside: false,fixedBgPos: true,
		fixedContentPos: true,
      gallery: {
  		enabled: true
		}
    });
  }
  
  
  $('#site-credits-trigger').on('click', function(e) {
      e.preventDefault();
      $('#site-credits').slideToggle();
      $('html, body').animate({ scrollTop: $(document).height()}, 'slow'); 
  })
  
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
    
    if ( $('input[name="partner[type]"]').length) {
      $('input[name="partner[type]"]').change(function(){
		if($(this).val()=="Other") {
      		$("input#partnerType").show();
		} else {
			$("input#partnerType").hide(); 
		}

	  });
      
    }
    
  	productBkgdSize();
  
  	spaOfferingsSize();
	
  /* header scrolling */
  	$globalWrapper = $('body:not(.index) .global-wrapper');
   	var promobannerHeight = 0;
	if ($('.promo_banner').length) promobannerHeight = $('.promo_banner').outerHeight();
    $navHeight = $('.mm-fixed-top').height() + promobannerHeight;
  	var headerHeight = 99;
    var contentPadding = -3;
  	if ($("#submenu").length) {
		headerHeight = $('#submenu').offset().top - $navHeight; //$('.mm-fixed-top').height();
    	contentPadding = $('#submenu').height() + contentPadding;
  	} else {
		headerHeight = $('#tfHeader').height() - $navHeight; //$('.mm-fixed-top').height() 
		contentPadding = contentPadding ; //$('.mm-fixed-top').height();
  	}

  
	$(window).scroll(function() {
	  if( $(this).scrollTop() > headerHeight && $(window).height()>667 && $(window).width()>767) {
	    $('.mm-fixed-top').css({ 'top': promobannerHeight });
        $('#submenu').addClass("nav-fixed").css({'top': promobannerHeight + $('.mm-fixed-top').height() });
	    $globalWrapper.css({'padding-top': contentPadding });
        //TODO: sticky sidebar menu on collection and product detail templates
      } else {
	    $('#submenu').removeClass("nav-fixed");
        if ( $(window).width()>767 ) {
          $('.mm-fixed-top').css({ 'top':'-80px' });
        } else {
          $('.mm-fixed-top').css({ 'top':'0px' });
        }
	    $globalWrapper.css({'padding-top': '0' });
	  }
      
      
	});
})


function productBkgdSize() {
  if ($('.product-bkgd').length) {
  	$bkgdSize = ($(window).width() - $('div.container').width()/2) + ($('div.container').width() * .4);
  	$bkgdSize = $(window).width() - $('.product-details').offset().left + 12;
  	$('.product-bkgd').css({'background-size':$bkgdSize });
  }
}

function spaOfferingsSize() {
  if ($('#spa-offerings').length) {
    $('#spa-offerings').css({'height': $(window).height()/2 });   
  }
}

function sizeInstafeed() {
  if ($('#insta-feed').length) {
    setTimeout(function(){
    	var elementHeights = $('#insta-feed img').map(function() {
    		return $(this).height();
  		}).get();
    	$('#insta-feed').css({'height': Math.max.apply(null, elementHeights) });
    }, 1000);
  }
}

function setMagnificLightboxHeight() {
	if ( $('.offering-details-container').length) {
      if ($(window).height()>$('.offering-details-container').height()) {
        $('.offering-details-container').css({'height':'auto'});
      } else {
         $('.offering-details-container').css({'height':'100%'});
      }  
	}
	if ( $('.staff-details-container').length) {
      if ($(window).height()>$('.staff-details-container').height()) {
        $('.staff-details-container').css({'height':'auto'});
      } else {
         $('.staff-details-container').css({'height':'100%'});
      }  
	}
}
  

$(window).on('load resize', function() {
  productBkgdSize();
  spaOfferingsSize();
  sizeInstafeed();
 // setMagnificLightboxHeight();
})



/* responsive columns (used on about for ingredients list) */
	function getWidth() {
	  var myWidth = 0;
	  if( typeof( window.innerWidth ) == 'number' ) {
	    //Non-IE
	    myWidth = window.innerWidth;
	  } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
	    //IE 6+ in 'standards compliant mode'
	    myWidth = document.documentElement.clientWidth;
	  } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
	    //IE 4 compatible
	    myWidth = document.body.clientWidth;
	  }
	  return myWidth;
	}
	/**
	 * @function
	 * @name adaptative_columns
	 * @see https://github.com/adamwulf/Columnizer-jQuery-Plugin
	 */
	function adaptative_columns (screenWidth) {
	    if (screenWidth > '1024') { // breckpoint Desktop
	        $('.ingredients-list').uncolumnize();
          	
	        $('.ingredients-list').columnize({
	            columns:4,
	           // buildOnce:false,
	            lastNeverTallest:true
	        });
	    }
	    if ((screenWidth < '1024') && (screenWidth > '767') ) { // breckpoint tablet
	        $('.ingredients-list').uncolumnize();
	        $('.ingredients-list').columnize({
	            columns:3,
	          //  buildOnce:false,
	            lastNeverTallest:true});
	    }
	    if (screenWidth<'767' && (screenWidth > '429') ) { // Breakpoint Phone
	        console.log("Mode Phones : "+screenWidth);
	        $('.ingredients-list').uncolumnize();
	        $('.ingredients-list').columnize({
	            columns:2,
	           // buildOnce:false,
	            lastNeverTallest:true});
	    }
	    if (screenWidth<'479') { // Breakpoint Phone
	        $('.ingredients-list').uncolumnize();
	    } 
      	
             	activatePopup()
	}


                
      
  function activatePopup() {
    $('.magnificIngredient').magnificPopup({
       type: 'inline', mainClass: 'mfp-fade', closeBtnInside: true,fixedBgPos: true, fixedContentPos: true,
      gallery: {
  		enabled: true
		},
		callbacks: {
          open: function() {
            $('body.page-about .mfp-wrap').css({'background-image':'url(//www.tammyfender.com/cdn/shop/t/14/assets/ingredient-bkgd.jpg?v=66445674233995441431785146092)'});
          },      
			change: function() {
			    jQuery('.mfp-wrap').scrollTop(0);
			}
    	}
    });
  }

	    $(document).ready(function(){
	        if ( $('.ingredients-list').length) {
  				var screenWidth = getWidth();
	        	adaptative_columns(screenWidth);
	        	$(window).resize(function(){
	        	   var screenWidth = getWidth();
	        	   adaptative_columns(screenWidth);
	        	});
            }
	    });
  

